module.exports = __webpack_public_path__ + "0eee28e2e9011999ddc6b4599c8873f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_4-mobile.png
// module id = 126
// module chunks = 1